import React from 'react';
import ReactDOM from 'react-dom/client';
import { StyleSheetManager } from 'styled-components';
import 'react-toastify/dist/ReactToastify.css';
import 'sweetalert2/dist/sweetalert2.min.css';
/* import './index.css'; */
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));

// Récupération du nonce (optionnel pour CRA avec 'unsafe-inline')
const nonce = window.CSP_NONCE || '';

root.render(
  <React.StrictMode>
    <StyleSheetManager 
      nonce={nonce}
      shouldForwardProp={(prop) => prop !== 'nonce'}
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StyleSheetManager>
  </React.StrictMode>
);

reportWebVitals();